import { useQuery } from '@tanstack/react-query';
import { stringify as toQueryString } from '@AppModels/QueryStringUtils';
import { IDictionary } from '../../extViewmodels';
import { useApiClientContext } from '../../surveys/context';

export const GET_STRIPE_PUBLISHABLE_KEY_BY_TOKEN_QUERY_KEY = 'stripe/auth/publishable-key/byToken?token=';

export const useStripePublishableKeyByToken = ({
	accessToken,
	enabled = true,
	refetchOnWindowFocus = false,
	options = {},
}: {
	accessToken?: string;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	options?: IDictionary<string>;
}) => {
	const { apiClient } = useApiClientContext();

	return useQuery({
		enabled,
		queryFn: () => {
			return apiClient.get<string>(
				`stripe/auth/publishable-key/byToken?${toQueryString({ token: accessToken, ...options })}`
			);
		},
		queryKey: [GET_STRIPE_PUBLISHABLE_KEY_BY_TOKEN_QUERY_KEY, accessToken, options],
		refetchOnWindowFocus,
	});
};
